import React from "react";
import PropTypes from "prop-types";
import AdminSubHeader from "../../../layouts/partials/AdminSubheader";
import UserForm from "../../../forms/UserForm";
import { connect } from "react-redux";
import { selectGroups } from "../../../../redux/groups/selectors";
import { GROUPS_ACTIONS } from "../../../../redux/groups/actions";
import { USERS_ACTIONS } from "../../../../redux/users/actions";
import { userCreating, userErrors } from "../../../../redux/users/selectors";

class UsersCreate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this._handleSubmit = this._handleSubmit.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.loadGroups();
  }

  componentWillUnmount() {
    this.props.resetErrors();
  }

  static propTypes = {
    loginRequest: PropTypes.func,
    groups: PropTypes.array,
    permissionsRequest: PropTypes.func,
    loadGroups: PropTypes.func,
    createUser: PropTypes.func,
    userErrors: PropTypes.object,
    isCreating: PropTypes.bool,
    resetErrors: PropTypes.func
  };

  _handleSubmit(values) {
    const data = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      permissionPresetId: parseInt(values.group, 10),
      password: values.password
    };

    const permissions = {
      permissionIds: values.permissions
    };

    this.props.createUser(data, permissions);
  }

  render() {
    const breadcrumbs = [
      {
        title: "Users",
        to: "/admin/users"
      }
    ];

    const { groups, isCreating, userErrors } = this.props;

    return [
      <AdminSubHeader
        title="Create User"
        key="subheader"
        breadcrumbs={breadcrumbs}
      />,
      <div className="m-content" key="content">
        {groups.length > 0 && (
          <UserForm
            onSubmit={this._handleSubmit}
            groups={groups}
            formSubmitting={isCreating}
            ajaxErrors={userErrors}
          />
        )}
      </div>
    ];
  }
}

const mapStateToProps = (state, props) => ({
  groups: selectGroups(state),
  isCreating: userCreating(state),
  userErrors: userErrors(state)
});

const mapDispatchToProps = dispatch => ({
  loadGroups: () => dispatch(GROUPS_ACTIONS.loadAllRequest()),
  resetErrors: () => dispatch(USERS_ACTIONS.resetErrors()),
  createUser: (values, permissions) =>
    dispatch(USERS_ACTIONS.createRequest(values, permissions))
});

export default connect(mapStateToProps, mapDispatchToProps)(UsersCreate);
